import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { withRouter, useHistory } from "react-router";

import { customerConstants } from "../../../../../../../constants";
import { NavigateToPathWithGo } from "../../../../../../../system";
import ViewGallery from "../../../../../../../shared/components/ViewGallery/ViewGallery";
import useGetQueryParams from "../../../../../../../shared/components/CustomHooks/GetQueryParams";
import { customerDashboardActions } from "../../../../../../../redux/actions";
import Modal from "../../../../../../../container/Views/Login/Modal";

const SharedGallery = (props) => {
  const history = useHistory();
  const queryParams = useGetQueryParams();

  const [files, setFiles] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);

  // navigate to screen after login
  useEffect(() => {
    let eventId = queryParams.get("eventid");
    const groupEventId = queryParams.get("groupeventid");

    // Backward compatibility for old eventId format
    if (eventId && !eventId.includes("-")) {
      eventId = `${eventId}-1`;
    }

    NavigateToPathWithGo(history, "/SharedGallery", "SharedGallery");
    props.getMyEventsAccessGallery(eventId, groupEventId, setFiles);

    // eslint-disable-next-line
  }, []);

  return (
    <div className="shared-gallery container my-3 py-1 custom-min-height">
      {props.isAuthenticated ? (
        <p>
          welcome to the {props.myEventsAccessGallery.eventName} gallery. we
          hope you enjoy the content below.
        </p>
      ) : (
        <div>
          {!isModalOpen ? (
            <p>
              welcome to the {props.myEventsAccessGallery.eventName} gallery. we
              hope you enjoy the content below. Please create a{" "}
              <strong
                className="login-btn"
                onClick={() => setIsModalOpen(true)}
              >
                login here
              </strong>{" "}
              to download multiple images and videos at once, and to save this
              gallery to your attended events within your shutterb account.
            </p>
          ) : (
            ""
          )}
        </div>
      )}
      {!props.isAuthenticated && isModalOpen && (
        <Modal setIsModalOpen={setIsModalOpen} />
      )}
      {!isModalOpen ? (
        <div>
          {files?.length > 0 ? (
            <ViewGallery
              files={files}
              setFiles={setFiles}
              selectedFiles={selectedFiles}
              setSelectedFiles={setSelectedFiles}
              isModalAllowed
              isAllowDownload
              hideDeleteIcon
              isShareAllowed
              isTabsDisplay
              showHearthIcon={false}
            />
          ) : (
            <p>
              sorry the event content is not ready yet, please check back within
              24 hours of the event ending.
            </p>
          )}
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  isAuthenticated: state.authentication.isAuthenticated,
  myEventsAccessGallerUrl:
    state.customerDashboard.myEventsAccessGallery.sharedGalleryUrl,
  myEventsAccessGallery: state.customerDashboard.myEventsAccessGallery,
});

const mapDispatchToProps = (dispatch) => ({
  getMyEventsAccessGallery: (eventId, groupEventId, setFiles) =>
    dispatch(
      customerDashboardActions.myEventsAccessGallery(
        eventId,
        groupEventId,
        setFiles,
        customerConstants.SHARED_GALLERY_CALL
      )
    ),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(SharedGallery));
